/**
 *
 * @constructor
 */
function TermsAndConditionsPage() {
    /**
     *
     */
    TermsAndConditionsPage.prototype.initialize = function (console, previousPage) {
        this.id = "termsAndConditions";
        this.console = console;
        this.previousPage = previousPage;

        return this;
    };

    /**
     *
     */
    TermsAndConditionsPage.prototype.show = function () {
        var deferred = $.Deferred();

        deferred.resolve();

        return deferred.promise();
    };

    /**
     *
     */
    TermsAndConditionsPage.prototype.leave = function () {
    };

    /**
     *
     */
    TermsAndConditionsPage.prototype.accept = function () {
        this.previousPage.acceptTermsAndConditions = true;
        this.console.popPage();
    };
}
